import { Clock, User } from "lucide-react";

import { type DateInput } from "@/shared/datetime";
import { Principal } from "@/shared/principal";

import { EntityDate } from "./EntityDate";
import { type EntityHeaderFact } from "./EntityHeader";
import { AutomationIcon, CreatedBy } from "./FactValues";

interface AuditFields {
  created?: DateInput | null;
  createdBy?: string | null;
}

/**
 * The items that lead every resource header's meta line: who created the
 * record (a user, or an action's ID by a sparkle), then "Created" and the
 * day. A field the record lacks is left out.
 */
export function auditFacts({
  created,
  createdBy,
}: AuditFields): EntityHeaderFact[] {
  const facts: EntityHeaderFact[] = [];
  if (createdBy) {
    const principal = Principal.fromString(createdBy).ok;
    const isUser = principal === undefined || principal.ptype === "user";
    facts.push({
      key: "created-by",
      icon: isUser ? <User /> : <AutomationIcon />,
      value: <CreatedBy createdBy={createdBy} isUser={isUser} />,
    });
  }
  if (created) {
    facts.push({
      key: "created",
      icon: <Clock />,
      label: "Created",
      value: <EntityDate value={created} />,
    });
  }
  return facts;
}
